'use strict';

const staticSlotSettings = {
	leaderboard1: {
		id: 'leaderboard-1',
		position: 'inline-01',
		sizes: {
			desktop: [[970, 90], [970, 250]],
			mobile: [[320, 50], [320, 100]],
			sizeMapping: [
				[
					[1024, 0], [[970, 250], [728, 90]]
				],
				[
					[748, 0], [[728, 90]]
				],
				[
					[488, 0], [[320, 100], [320, 50]]
				],
				[
					[0, 0], [[320, 100], [320, 50]]
				]
			]
		}
	},

	leaderboardGallery: {
		id: 'leaderboard-gallery',
		position: 'leaderboard-gallery',
		sizes: {
			desktop: [[728, 90]],
			mobile: [[320, 50], [320, 100]]
		}
	},

	mpuGallery: {
		id: 'mpu-gallery',
		position: 'mpu-gallery',
		sizes: {
			desktop: [[300, 250], [300, 600]],
			mobile: [[300, 250]]
		}
	},

	native01: {
		id: 'native-01',
		position: 'native-01',
		sizes: {
			desktop: [[300, 250], [300, 600]],
			mobile: [[300, 250]],
			sizeMapping: [
				[
					[1024, 0], [[300, 250], [300, 600]]
				],
				[
					[747, 0], [[300, 250], [300, 600], [320, 480]]
				],
				[
					[488, 0], [[300, 250], [300, 600]]
				],
				[
					[340, 0], [[300, 250], [300, 600], [320, 480]]
				],
				[
					[0, 0], [[300, 250], [300, 600]]
				]
			]
		}
	},

	native02: {
		id: 'native-02',
		position: 'native-02',
		sizes: {
			desktop: [[300, 250], [300, 600]],
			mobile: [[300, 250]],
			sizeMapping: [
				[
					[1024, 0], [[300, 250], [300, 600]]
				],
				[
					[747, 0], [[300, 250], [300, 600], [320, 480]]
				],
				[
					[488, 0], [[300, 250], [300, 600]]
				],
				[
					[340, 0], [[300, 250], [300, 600], [320, 480]]
				],
				[
					[0, 0], [[300, 250], [300, 600]]
				]
			]
		}
	},

	overlay: {
		id: 'overlay',
		position: 'overlay',
		sizes: {
			desktop: [[1, 1]],
			mobile: [[1, 1]]
		}
	},

	inlineFooter: {
		id: 'inline-footer',
		position: 'inline-footer',
		sizes: {
			desktop: [[300, 250], [300, 600], [320, 480], [640, 380], [640, 480], [728, 90], [970, 250]],
			mobile: [[300, 250], [300, 600], [320, 480]],
			sizeMapping: [
				[
					[1024, 0], [[300, 250], [300, 600], [320, 480], [640, 380], [640, 480], [728, 90], [970, 250]]
				],
				[
					[747, 0], [[300, 250], [300, 600], [320, 480], [640, 380], [640, 480], [728, 90]]
				],
				[
					[488, 0], [[300, 250], [300, 600], [320, 480]]
				],
				[
					[340, 0], [[300, 250], [300, 600], [320, 480]]
				],
				[
					[0, 0], [[300, 250], [300, 600]]
				]
			]
		}
	},

	seedTag: {
		id: 'in_image',
		position: 'in_image',
		sizes: {
			desktop: [[1, 3]],
			mobile: [[1, 3]]
		}
	},

	gumGum: {
		id: 'sticky_ad_bottom',
		position: 'sticky_ad_bottom',
		sizes: {
			desktop: [[1, 2]],
			mobile: [[1, 2]]
		}
	},

	contentRecommendation1: {
		id: 'content-rec-01',
		sizes: {
			desktop: [[300, 250]],
			mobile: [[300, 250]]
		}
	},

	contentRecommendation2: {
		id: 'content-rec-02',
		sizes: {
			desktop: [[300, 250]],
			mobile: [[300, 250]]
		}
	},

	contentRecommendation3: {
		id: 'content-rec-03',
		sizes: {
			desktop: [[300, 250]],
			mobile: [[300, 250]]
		}
	}
};

const flexibleSlotSettings = {
	sizeMapping: [
		[
			[1024, 0], [[300, 250], [300, 600], [320, 480], [640, 380], [640, 480], [728, 90], [970, 250]]
		],
		[
			[748, 0], [[300, 250], [300, 600], [320, 480], [640, 380], [640, 480], [728, 90]]
		],
		[
			[488, 0], [[320, 50], [320, 100], [320, 480], [300, 250], [300, 600]]
		],
		[
			[0, 0], [[320, 50], [320, 100], [320, 480], [300, 250], [300, 600]]
		]
	],
	sizes: [[300, 250], [300, 600], [320, 50], [320, 100], [320, 480], [640, 380], [640, 480], [728, 90], [970, 250]]
};


export default {
	flexibleSlotSettings,

	getSlotSettings: (maxMpuCount) => {
		let slotSettings = Object.assign({}, staticSlotSettings);

		for (let i = 1; i <= maxMpuCount; i++) {
			let mpuSlotKey = 'mpu' + i;
			let mpuId = 'mpu-' + i;

			// top leaderboard is inline-01 so add 1 to mpu index to make is postion
			let position = 'inline-' + (i + 1).toLocaleString('en-GB', {
				minimumIntegerDigits: 2,
				useGrouping: false
			});

			slotSettings[mpuSlotKey] = {
				id: mpuId,
				position: position,
				sizes: {
					desktop: [[300, 250], [300, 600]],
					mobile: [[300, 250], [300, 600]]
				}
			}
		}

		return slotSettings;
	}
};